export type DogAgeRange =
  | "puppy"
  | "young_adult"
  | "adult"
  | "mature_adult"
  | "senior"
  | "golden_oldie"

export const DOG_AGE_RANGE_OPTIONS: { value: DogAgeRange; label: string }[] = [
  { value: "puppy", label: "Puppy (Under 1 year)" },
  { value: "young_adult", label: "Young Adult (1–2 years)" },
  { value: "adult", label: "Adult (3–6 years)" },
  { value: "mature_adult", label: "Mature Adult (7–9 years)" },
  { value: "senior", label: "Senior (10–12 years)" },
  { value: "golden_oldie", label: "Golden Oldie (13+ years)" },
]
